import React from "react";
import { NavItem, NavLink } from "reactstrap";
import { useHistory } from "react-router-dom";
import AuthLogin from "../../Utils/AuthLogin";
import { Link } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import Menu from "../../Menu";

const HomeLayout = ({ children, ...rest }) => {
    const { push } = useHistory();
    const auth = new AuthLogin();
    let menuJson = auth.menu();
    let data = JSON.parse(menuJson);
    let menu = new Menu(data);
    let customMenu = [];

    const [loading, setLoading] = React.useState(false);
    if (auth.username() == null) {
        auth.logout();
        push({
            pathname: "/login",
        });
    }

    if (auth.getReloadHome() === "0") {
        auth.setReloadHome(1);
        window.location.reload(false);
    }

    const handleClickLogOut = (e) => {
        auth.logout();
        push({
            pathname: "/login",
        });
    };
    return (
        <div>
            <Spinner show={loading} />
            <div className="page-container">
                <div className="page-sidebar">
                    <ul className="x-navigation">
                        <li className="xn-profile">
                            <a href="#/" className="profile-mini">
                                <img
                                    src="/img/congreso-logo.svg"
                                    alt="John Doe"
                                />
                            </a>
                            <div className="profile">
                                <a
                                    href="#/"
                                    className="x-navigation-control"
                                />
                                <div className="profile-image">
                                    <img
                                        src="/img/congreso-logo.svg"
                                        alt="John Doe"
                                    />
                                </div>
                                <div className="profile-data">
                                    <div className="profile-data-name">
                                        Universidad de los Andes
                                    </div>
                                    <div className="profile-data-title">
                                        Facultad de Ciencias Sociales
                                    </div>
                                </div>
                            </div>
                        </li>
                        {
                            getMenuPrincipal(menu, customMenu)
                        }
                    </ul>
                </div>
                <div
                    className="page-content"
                    style={{ height: "auto !important" }}
                >
                    <ul className="x-navigation x-navigation-horizontal x-navigation-panel">
                        <li className="xn-icon-button bar">
                            <a
                                href="#/"
                                className="x-navigation-minimize"
                                style={{ width: "auto" }}
                            >
                                <span
                                    className="fa fa-bars"
                                    style={{
                                        width: "30px",
                                        textAlign: "center",
                                    }}
                                ></span>
                            </a>
                        </li>
                        <li className="xn-icon-button pull-right">
                            <a
                                href="#/"
                                className="mb-control"
                                data-box="#mb-signout"
                            >
                                <span className="fa fa-sign-out-alt"></span>{" "}
                                Cerrar sesión
                            </a>
                        </li>
                        <li className="xn-icon-button pull-right">
                            <h5
                                className="login-title text-center"
                                style={{
                                    textAlign: "center",
                                    color: "var(--blue-secondary)",
                                    marginBottom: "0px",
                                    marginTop: "7px",
                                    fontSize: "12px",
                                }}
                            >
                                {" "}
                                {auth.nombre_completo() !== null ? `${auth.nombre_completo()}` : ""}
                            </h5>
                            <h5
                                className="login-title text-center"
                                style={{
                                    textAlign: "center",
                                    color: "var(--blue-secondary)",
                                    marginBottom: "0px",
                                    marginTop: "7px",
                                    fontSize: "12px",
                                }}
                            >
                                {" "}
                                {auth.email() !== null
                                    ? `${auth.email()}`
                                    : ""}
                            </h5>
                        </li>
                    </ul>
                    {children}
                </div>
            </div>

            <div
                className="message-box animated fadeIn"
                data-sound="alert"
                id="mb-signout"
            >
                <div className="mb-container">
                    <div className="mb-middle">
                        <div className="mb-title">
                            <span className="fa fa-sign-out"></span> ¿Cerrar
                            sesión?
                        </div>
                        <div className="mb-content">
                            <p>¿Desea cerrar la sesión?</p>
                            <p>Sí desea cerrar la sesión presione sí.</p>
                        </div>
                        <div className="mb-footer">
                            <div className="pull-right">
                                <button className="btn btn-default btn-lg mb-control-close">
                                    No
                                </button>
                                <NavLink
                                    to="/"
                                    onClick={handleClickLogOut}
                                    className="btn btn-success btn-lg"
                                >
                                    Sí
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <audio
                id="audio-alert"
                src="audio/alert.mp3"
                preload="auto"
            ></audio>
            <audio id="audio-fail" src="audio/fail.mp3" preload="auto"></audio>
        </div>
    );
};

function getMenuPrincipal(menu, customMenu) {
    if (!menu) return customMenu;
    for (let i = 0; i < Object.keys(menu).length; i++) {
        if (
            menu[i].subMenus != null &&
            menu[i].subMenus.filter((x) => x.visible > 0).length > 0
        ) {
            customMenu.push(
                <NavItem key={i} className="xn-openable">
                    <a href="/#">
                        <span className={menu[i].icono}/>
                        <span className={menu[i].class_name}>
                            {menu[i].nombre_visible}
                        </span>
                    </a>
                    <ul>{getSubMenu(menu[i])}</ul>
                </NavItem>
            );
        }
        else if (menu[i].visible)
        {
            if (!menu[i].url)
            {
                menu[i].url = "/";
            }
            customMenu.push(
                <NavItem key={i}>
                    <NavLink key={i} tag={Link} to={"/" + menu[i].url} replace>
                        <span className={menu[i].icono}/>
                        <span className={menu[i].class_name}>
                            {menu[i].nombre_visible}
                        </span>
                    </NavLink>
                </NavItem>
            );
        }
    }

    return customMenu;
}

function getSubMenu(menu) {
    let subMenu = [];
    for (let i = 0; i < menu.subMenus.length; i++) {
        if (menu.subMenus[i].visible) {
            subMenu.push(
                <NavItem key={i}>
                    <NavLink tag={Link} to={"/" + menu.subMenus[i].url} replace>
                        <span className={menu.subMenus[i].icono}/>
                        <span className={menu.subMenus[i].class_name}>
                            {menu.subMenus[i].nombre_visible}
                        </span>
                    </NavLink>
                </NavItem>
            );
        }
    }
    return subMenu;
}
export default HomeLayout;
